class KlaviyoUnsubscribe extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector(".klaviyo-unsubscribe__form")
    this.form.addEventListener("submit", this.handleSubmit.bind(this))
  }

  handleSubmit(e) {
    console.log("handleSubmit")
    e.preventDefault()
    var email = this.form.querySelector("#klaviyo-email").value
    var data = {
      token: this.form.getAttribute("data-klaviyo-id"),
      event: "Unsubscribe",
      customer_properties: {
        $email: email,
      },
      customerEmail: email,
      properties: {
        sourceSystem: "Web Unsubscribe Page",
        brandCode: this.form.getAttribute("data-brand-code"),
      },
    }
    const options = {
      method: "POST",
      headers: {
        accept: "text/html",
        "content-type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        data: JSON.stringify(data),
      }),
    }

    fetch("https://a.klaviyo.com/api/track", options)
      .then((response) => response.json())
      .then(() => this.showSuccessMessage())
      .catch((err) => this.showErrorMessage())
  }

  showSuccessMessage() {
    this.classList.add("success")
  }

  showErrorMessage() {
    this.innerHTML = `<p>There was an error. Please try again.</p></p>`
  }
}

customElements.define("klaviyo-unsubscribe", KlaviyoUnsubscribe)
